module.exports = "<div class=\"padding-20\">\r\n  <div class=\"padding-10 margin-b-10 bgc bgc-primary text-a-center\">\r\n    <h1>Driver Schedule</h1>\r\n  </div>\r\n  <app-driver-schedule></app-driver-schedule>\r\n  <app-t2-loading #appT2Loading></app-t2-loading>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/popup-driver-schedule/popup-driver-schedule.component.html
// module id = 2489
// module chunks = 66